import { useAtomValue, useSetAtom } from 'jotai'
import { phasesAtom, updatePhaseAtom } from '../atoms/reviewPricing.atoms'
import invariant from 'tiny-invariant'
import { useCallback } from 'react'
import { Phase } from '../atoms/reviewPricing.primitives.atoms'

export const usePhase = (phaseId: string) => {
  const phases = useAtomValue(phasesAtom)
  const phase = phases.find(phase => phase.id === phaseId)
  const setPhase = useSetAtom(updatePhaseAtom)

  const updatePhase = useCallback(
    (update: Partial<Phase>) => {
      setPhase({ id: phaseId, update })
    },
    [setPhase, phaseId]
  )

  invariant(phase, 'Phase not found')
  return {
    phase,
    updatePhase
  }
}
